import { useEffect, useState } from "react";
import { api } from "./api.js";

/**
 * Fetches an evidence asset's bytes (authenticated - can't just be an <img
 * src="/evidence/:id/content">, browsers don't attach custom headers to
 * image requests) and renders them as an object URL. Only "available"
 * assets have bytes worth showing; other states already show a status
 * label in the list above this.
 */
export function EvidenceThumbnail({ assetId }: { assetId: string }) {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let url: string | null = null;
    setFailed(false);
    api
      .evidenceContent(assetId)
      .then((blob) => {
        if (cancelled) return;
        url = URL.createObjectURL(blob);
        setObjectUrl(url);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [assetId]);

  if (failed) return null;
  if (!objectUrl)
    return (
      <div
        className="evidence-thumbnail-loading"
        aria-label="Loading receipt image"
      />
    );
  return <img className="evidence-thumbnail" src={objectUrl} alt="Receipt" />;
}
